<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Products
        <small>List of products</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <span>Products</span>
        </li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="button-flagging">
        <a v-if="params.flaging === 'explore'" 
          class="btn active-flag disabled"
          :class="!need_approve_explore ? 'margin-right' : ''"
          disabled>
          Explore Products
        </a>
        <a v-else class="btn btn-primary"
          @click.prevent="changeFlag()">
          Explore Products
        </a>
        <span v-if="need_approve_explore" class="badge notif-badge">!</span>
        <a v-if="params.flaging === 'tour'" 
          class="btn active-flag disabled"
          :class="!need_approve_explore ? 'margin-left' : ''"
          disabled>
          Tour Products
        </a>
        <a v-else class="btn btn-primary"
          @click.prevent="changeFlag()">
          Tour Products
        </a>
        <span v-if="need_approve_tour" class="badge notif-badge">!</span>
      </div>

      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Products</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="row">
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="vendor">
                  Source Product
                </label>

                <select @change="onSelect" v-model="params.vendor" class="form-control" id="vendor">
                  <option :value="null">Select All</option>
                  <option  v-for="(data, index) in list.vendors" :key="`${index}-${data.value}`" :value="data.value">
                  {{ data.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="status">
                  Status Live
                </label>

                <select @change="onSelect" v-model="params.status" class="form-control" id="status">
                  <option :value="null">All Status Live</option>
                  <option value="publish">Published</option>
                  <option value="unpublish">Unpublished</option>
                  <option value="draft">Draft</option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="status_product">
                  Status Product
                </label>

                <select @change="onSelect" v-model="params.status_product" class="form-control" id="status_product">
                  <option :value="null">All Status Product</option>
                  <option value="Need Approval">Need Approval</option>
                  <option value="Need Revision">Need Revision</option>
                  <option value="Approved">Approved</option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="name">
                  Merchant
                </label>

                <select @change="onSelect" v-model="params.merchant_id" class="form-control" id="merchant">
                  <option :value="null">Select All</option>
                  <option  v-for="(data, index) in list.merchants" :key="`${index}-${data.value}`" :value="data.value">
                  {{ data.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="name">
                  Name
                </label>

                <input type="text"
                  class="form-control"
                  id="name"
                  placeholder="Search by name here"
                  v-model="params.name"
                  @keyup="onInput">
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="category">
                  Category
                </label>

                <input type="text"
                  class="form-control"
                  id="category"
                  placeholder="Search by categories here"
                  v-model="params.category"
                  @keyup="onInput">
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="destination">
                  Destination
                </label>

                <input type="text"
                  class="form-control"
                  id="destination"
                  placeholder="Search by destination here"
                  v-model="params.destination"
                  @keyup="onInput">
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="destination">
                  Sequence
                </label>

                <input type="number"
                  class="form-control"
                  id="destination"
                  placeholder="Search by sequence here"
                  v-model="params.sequence"
                  @keyup="onInput">
              </div>
            </div>
            <div class="box-footer">
              <button type="button" 
                class="btn btn-success" 
                @click="onExportCsv('normal')">
                Export CSV
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Horizontal Form -->
      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Products
          </a>
        </div>
        <!-- /.box-header -->
        <div class="box-body table-responsive">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th style="min-width: 24rem">Product Name</th>
                <th class="table-sort" style="min-width: 5rem">
                  <label>Sequence</label>
                  <img
                    :src="`/static/icons/icon-sort-${sort.status ? 'asc' : 'desc'}.png`"
                    alt="icon sort"
                    @click.self="sortList('sequence')"
                  >
                </th>
                <th style="min-width: 15rem">Source</th>
                <th style="min-width: 10rem">Merchant</th>
                <th style="min-width: 15rem">Category</th>
                <!-- <th style="min-width: 15rem">Mood</th> -->
                <th style="min-width: 15rem">Destination</th>
                <th style="min-width: 15rem">Tags</th>
                <th style="min-width: 12rem">Start Date</th>
                <th style="min-width: 12rem">End Date</th>
                <th style="min-width: 18rem">Price Range</th>
                <th style="min-width: 11rem">Status Product</th>
                <th style="min-width: 10rem">Status Live</th>
                <th style="min-width: 18rem">Created By</th>
                <th style="min-width: 18rem">Approved By</th>
                <th style="min-width: 18rem">Last Edit By</th>
                <th style="min-width: 18rem">Last Edit At</th>
                <th style="min-width: 10rem">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="13">
                  <strong>Loading...</strong>
                </td>
              </tr>
              <tr v-else-if="!isLoading && products.length < 1">
                <td colspan="13">
                  Result not found
                </td>
              </tr>
              <tr v-for="product in products" :key="product.id" v-else>
                <td>
                  <router-link :to="{ ...redirectEdit, params: { id: product.id } }">
                    {{ product.name }}
                  </router-link>
                </td>
                <td>
                  <span>
                    {{ product.sequence }}
                  </span>
                </td>
                <td>
                  <span class="label label-default">
                    {{ product.vendor_name }}
                  </span>
                </td>
                <td>
                  <span class="label label-default">
                    {{ product.merchant.name }}
                  </span>
                </td>
                <td>
                  <div v-for="(item, index) in product.categories"
                    :key="`${index}-${item.id}-${item.slug}`">
                    <span class="label label-default">
                      {{ item.name }}
                    </span>
                  </div>
                </td>
                <!-- <td>
                  <span class="label label-default"
                    v-for="(item, index) in product.moods"
                    :key="`${index}-${item.id}-${item.slug}`">
                      {{ item.name }}
                    </span>
                </td> -->
                <td>
                  <div v-for="(item, index) in product.destinations"
                    :key="`${index}-${item.id}-${item.slug}`">
                    <span class="label label-default">
                      {{ item.name }}
                    </span>
                  </div>
                </td>
                <td>
                  <span class="label label-default" v-if="product.can_be_canceled">Tidak dapat dibatalkan</span>
                  <span class="label label-default" v-if="product.duration_1_day">Durasi: 1 hari</span>
                  <span class="label label-default" v-if="product.duration_2_day">Durasi: 2 hari</span>
                  <span class="label label-default" v-if="product.is_open_date">Open date ticket</span>
                  <span class="label label-default" v-if="product.is_fixed_date">Fixed date ticket</span>
                  <span class="label label-default" v-if="product.changed_voucher">Tukar voucher dengan tiket fisik</span>
                  <span class="label label-default" v-if="product.print_voucher">Cetak voucher</span>
                </td>
                <td>
                  <template v-if="checkBookingDateType(product.booking_date)">
                    {{ parseTime(product.booking_date[0].from, 'DD MMMM YYYY') }}
                  </template>
                  <template v-else>
                    {{ parseBookingDate(product.booking_date, 'from') }}
                  </template>
                </td>
                <td>
                  <template v-if="checkBookingDateType(product.booking_date)">
                    {{ parseTime(product.booking_date[0].to, 'DD MMMM YYYY') }}
                  </template>
                  <template v-else>
                    {{ parseBookingDate(product.booking_date, 'to') }}
                  </template>
                </td>
                <td>
                  IDR {{ digitGrouping(product.lowest_price) }} - {{ digitGrouping(product.highest_price) }}
                </td>
                <td>
                  {{ product.status_product}}
                </td>
                <td>
                  {{ product.status }}
                </td>
                <td>
                  <span v-if="product.created_by_email">{{ product.created_by_email }}</span>
                  <span v-else> - </span>
                </td>
                <td>
                  <span v-if="product.approved.email">{{ product.approved.email }}</span>
                  <span> - </span>
                </td>
                <td>
                  <span v-if="product.updated_by_email">{{ product.updated_by_email }}</span>
                  <span v-else> - </span>
                </td>
                <td>
                  {{ parseTime(product.updated_at, 'DD MMM YYYY | HH:mm') }}
                </td>
                <td>
                  <a class="btn btn-primary btn-xs"
                    @click.prevent="edit(product.id)">
                    Edit
                  </a>
                  <a class="btn btn-danger btn-xs"
                    @click.prevent="remove(product)">
                    Delete
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <transition name="modal">
          <div class="modal-mask" @click.self="modalError = !modalError" v-if="modalError">
            <div class="modal-wrapper">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" @click.prevent="modalError = !modalError">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" style="text-align: center">Please input Status Live before export the data</h4>
                  </div>
                  <div class="modal-body" style="text-align: center">
                    <div class="row">
                      <div class="col-12 col-sm-12">
                        <div class="form-group">
                          <label>You can choose Published, Unpublished or Draft in parameter Status Live</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import moment from 'moment';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';
import Modal from '@/components/modules/common/Modal';
import API_BASEURL from '../../../config';

export default {
  name: 'ProductIndex',

  mixins: [Common],

  components: {
    Pagination,
    Modal,
  },

  data() {
    return {
      products: [],
      pagination: {},

      isLoading: false,
      modalError: false,

      params: {
        flaging: null,
        name: null,
        mood: null,
        category: null,
        merchant_id: null,
        destination: null,
        sequence: null,
        status: null,
        status_product: null,
        page: null,
        vendor: null,
        export_csv: 0,
        sort_field: null,
        sort_order: null,
      },

      need_approve_explore: false,
      need_approve_tour: false,

      list: {
        vendors: null,
        merchants: null,
      },

      sort: {
        field: '',
        status: false,
      },
    };
  },

  watch: {
    'params.page': {
      handler: (val) => {
        this.fetch(val);
      },
      deep: false,
    },

    sort(newVal) {
      this.params = {
        ...this.params,
        sort_field: newVal.field,
        sort_order: newVal.status ? 'asc' : 'desc',
      };
      this.fetch();
    },
  },

  computed: {
    redirectEdit() {
      return {
        name: 'product-edit',
        params: {},
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      };
    },
  },

  methods: {
    getApiRoute() {
      let route = '';
      if (this.params.flaging === 'tour') {
        route = '/products-tour?b2b_type=internal';
      } else {
        route = '/products?b2b_type=internal';
      }
      return route;
    },

    fetch(page = null) {
      if (page && typeof page !== 'object') this.params.page = page;

      const route = this.getApiRoute();
      this.setProductsEmpty();
      this.fetchNeeedApproval();

      this.isLoading = true;

      this.axios.get(route, {
          params: this.params,
          responseType: this.type,
        })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.setProductsEmpty();
            return;
          }

          this.products = data.filter(dt => !!dt.id);
          this.pagination = meta.pagination;
        })
        .finally(() => {
          this.setParamsAndQueries();
          this.isLoading = false;
        });
    },

    checkBookingDateType(bookingDate) {
      return typeof bookingDate !== 'string';
    },

    onInput: debounce(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    onSelect() {
      this.params.page = null;
      this.fetch();
    },

    async onExportCsv() {
      let params = '';
      this.params.export_csv = 1;

      const totalRow = this.pagination.total;
      const queryParams = this.params;

      Object.keys(queryParams).forEach((key) => {
        params += `${key}=${queryParams[key] || ''}&`;
      });
      
      params = params.slice(0, -1);
      if (this.params.status) {
        let url = '';
        url = `${API_BASEURL}/products?${params}&perpage=${totalRow || ''}`;
        
        window.location = url;
        this.params.export_csv = 0;
      } else {
        this.modalError = true;
        this.params.export_csv = 0;
      }
    },

    setProductsEmpty() {
      this.products = [];
      this.pagination = {};
    },

    changePage(page) {
      this.fetch(page);
    },

    parseBookingDate(booking, target) {
      const bookingDate = JSON.parse(booking);
      const bookingLength = bookingDate.length;

      if (bookingLength < 1) return null;

      if (target === 'from') {
        const fromDate = bookingDate[0].from;
        return this.parseTime(fromDate, 'DD MMM YYYY');
      }

      const toDate = bookingDate[bookingLength - 1].to;
      return this.parseTime(toDate, 'DD MMM YYYY');
    },

    add() {
      this.$router.push({
        name: 'product-create',
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      });
    },

    edit(id) {
      this.$router.push({ ...this.redirectEdit, params: { id } });
    },

    delete(product) {
      this.axios.delete(`/products/${product.id}`)
        .then(() => {
          this.fetch();
          this.$swal(
            'Deleted!',
            `${product.name} has been deleted.`,
            'success',
          );
        });
    },

    remove(product) {
      this.$swal({
        title: 'Deleting Product',
        text: `Are you sure you want to delete ${product.name}? This action cannot be undone.`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((result) => {
        if (result.value) {
          this.delete(product);
        }
      }, (dismiss) => {
        if (dismiss === 'cancel') {
          this.$swal(
            'Cancelled',
            null,
            'error',
          );
        }
      });
    },

    sortList(target) {
      this.sort = { field: target, status: !this.sort.status };
    },

    parseStatus(status, booking) {
      const isActive = (status === 1);
      const statusText = (isActive) ? 'Published' : 'Unpublished';
      const bookingDate = JSON.parse(booking);
      const bookingLength = bookingDate.length;
      if (bookingLength < 1) return statusText;

      const toDate = bookingDate[bookingLength - 1].to;
      if (!toDate) return statusText;

      const isEnd = moment().isAfter(toDate, 'days');
      if (isActive && isEnd) return 'Unpublished';

      return (isActive) ? 'Published' : 'Unpublished';
    },

    parseParams() {
      this.params.flaging = this.$route.query.flaging || null;
      this.params.name = this.$route.query.name || null;
      this.params.mood = this.$route.query.mood || null;
      this.params.category = this.$route.query.category || null;
      this.params.destination = this.$route.query.destination || null;
      this.params.sequence = this.$route.query.sequence || null;
      this.params.status = this.$route.query.status || null;
      this.params.status_product = this.$route.query.status_product || null;
      this.params.page = this.$route.params.page || null;
      this.params.vendor = this.$route.query.vendor || null;
      this.params.sort_field = this.$route.query.sort_field || null;
      this.params.sort_order = this.$route.query.sort_order || null;
    },

    setParamsAndQueries() {
      const page = this.params.page || 1;

      const queries = Object.keys(this.params)
        .filter(item => (this.params[item] && item !== 'page'))
        .map(item => `${item}=${this.params[item]}`)
        .join('&');

      window.history.pushState(`Products page: ${this.params.page}`, null, `/products/page/${page}?${queries}`);
    },

    async fetchNeeedApproval() {
      try {
        const response = await this.axios.get('/products-only/approval');
        const { data } = response;
        this.need_approve_explore = data.is_need_approval_explore;
        this.need_approve_tour = data.is_need_approval_tour;
      } catch (error) {
        console.log(error);
        this.$swal({
          title: 'Failed',
          text: 'Failed to fetch data Need approval',
          type: 'error',
          timer: 3000,
        });
      }
    },

    fetchVendors() {
      return this.axios.get('/vendors')
        .then((response) => {
          const vendorData = response.data.data;
          this.list.vendors =
            vendorData.map(item => ({ label: item.name, value: item.id }));
        })
        .catch((error) => {
          console.log('Fetch vendors error', error);
        });
    },
    fetchMerchants() {
      return this.axios.get('/merchants', { params: { perpage: 5000 } })
        .then((response) => {
          const merchantsData = response.data.data;
          this.list.merchants =
            merchantsData.map(item => ({ label: item.name, value: item.id }));
        })
        .catch((error) => {
          console.log('Fetch vendors error', error);
        });
    },
    setParamstoDefault() {
      this.params.name = null;
      this.params.mood = null;
      this.params.category = null;
      this.params.destination = null;
      this.params.sequence = null;
      this.params.status = null;
      this.params.status_product = null;
      this.params.page = null;
      this.params.vendor = null;
      this.params.export_csv = 0;
      this.params.sort_field = null;
      this.params.sort_order = null;
    },
    changeFlag() {
      if (this.params.flaging === 'explore') {
        this.params.flaging = 'tour';
      } else {
        this.params.flaging = 'explore';
      }
      this.setParamstoDefault();
      this.fetch();
    },
  },

  mounted() {
    this.parseParams();
    if (!this.params.flaging) {
      this.params.flaging = 'explore';
    }
    this.fetch();
    this.fetchVendors();
    this.fetchMerchants();
  },
};
</script>

<style lang="scss" scoped>
  @import '../orders/style.scss';
  .margin-right{
    margin-right: 20px;
  }

  .margin-left{
    margin-left: 20px;
  }

  .notif-badge {
    position: relative;
    left: -13px;
    top: -15px;
    background: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/products/Index.vue